var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.bfhsLoaded || _vm.bfhs.length)?_c('BfhsBlock',{attrs:{"bfhs":_vm.bfhs}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }